export const SNACKBAR_TIMEOUT = 5;  //seconds
export const LOGIN_REDIRECT = `/`;

const inferDefaultHost = (fallback = 'visist.ai') => {
  try {
    const host = typeof window !== 'undefined' && window.location ? window.location.hostname : '';
    if (/poc/i.test(host)) return 'poc.visist.ai';
    if (/(staging|stage)/i.test(host)) return 'staging.visist.ai';
    return fallback; // production
  } catch {
    return fallback;
  }
};

const DEFAULT_BORQS_HOST = process.env.REACT_APP_BORQS_HOST || inferDefaultHost('poc.visist.ai');

export const BORQS_URL = process.env.REACT_APP_BORQS_URL || `https://${DEFAULT_BORQS_HOST}`;
export const LLM_GATEWAY_URL = process.env.REACT_APP_LLM_GATEWAY_URL;

export const POST_REGISTRATION_OTP = `${BORQS_URL}/assetmgmt/user/otp`;
export const POST_OTP_REGISTRATION = `${BORQS_URL}/assetmgmt/user/otp-registration`;
export const POST_REGISTER = `${BORQS_URL}/assetmgmt/user/register`;
export const POST_REGISTER_LOGIN = `${BORQS_URL}/assetmgmt/user/register-login`;
export const POST_LOGIN_OTP = `${BORQS_URL}/assetmgmt/user/otp`;
export const POST_LOGIN_OTP_VERIFY = `${BORQS_URL}/assetmgmt/user/login`;
export const POST_CALENDAR_TEMPLATE_EP = `${BORQS_URL}/assetmgmt/user/logout`;
export const POST_REFRESH_TOKEN = `${BORQS_URL}/assetmgmt/user/token/refresh`;
export const GET_USER_INFO = `${BORQS_URL}/assetmgmt/user`;
export const GET_LEADGEN_PROFILE = `${BORQS_URL}/assetmgmt/leadgen/profiledata`;
export const POST_LEADGEN_PROFILE = `${BORQS_URL}/assetmgmt/leadgen/signup`;
export const PUT_UPDATE_USER_INFO = `${BORQS_URL}/assetmgmt/user`;
export const POST_USER_LOGOUT = `${BORQS_URL}/assetmgmt/user/logout`;
export const POST_UPDATE_USER_PIC = `${BORQS_URL}/assetmgmt/user/profile-pic`;
export const GET_USER_PIC = `${BORQS_URL}/assetmgmt/user/profile-pic`;
export const PUT_CREATE_GAME = `${BORQS_URL}/assetmgmt/post/?type=game`;
export const PUT_CREATE_GAME_AND_ASSIGN_TO_COACH = `${BORQS_URL}/assetmgmt/post/?type=game&state=review_requested`;
export const PUT_CREATE_REVIEW_POST = `${BORQS_URL}/assetmgmt/post/?type=review`;
export const GET_FETCH_GAME_POST_FILE = `${BORQS_URL}/assetmgmt/post/?type=game`;
export const DELETE_GAME_POST = `${BORQS_URL}/assetmgmt/post`;
export const MARK_FAV_GAME_POST = `${BORQS_URL}/assetmgmt/post/fav/`;
export const POST_LIST_ALL_COACHES = `${BORQS_URL}/assetmgmt/user/search`;
export const POST_UPDATE_REVIEW_SELECTION = `${BORQS_URL}/assetmgmt/post`; //NEED TO ADD ?postId=662d04c9089ef49fcb4b39e0
export const GET_FETCH_REVIEW_POST = `${BORQS_URL}/assetmgmt/post/?type=review&postId=`;
export const GET_FETCH_REVIEW_POST_FILE = `${BORQS_URL}/assetmgmt/post/?type=review`;
export const GET_ALL_POST_COPY = `${BORQS_URL}/assetmgmt/post/`;
export const GET_LIST_OF_POST_USER = `${BORQS_URL}/assetmgmt/post/qwerty`;
export const GET_A_POST = `${BORQS_URL}/assetmgmt/post/?postId=`
export const GET_POST_CONTENT = `${BORQS_URL}/assetmgmt/post` //NEED TO ADD ?postId=662d04c9089ef49fcb4b39e0
export const POST_ALL_POST_COUNT = `${BORQS_URL}/assetmgmt/post/searchCount`// NEED TO PASS BODY
export const GET_VIDEO_UPLOAD_QUOTA = `${BORQS_URL}/assetmgmt/user/{userId}/video-upload-quota?state=`// NEED TO PASS BODY 
export const POST_LIST_POST = `${BORQS_URL}/assetmgmt/post/search`// NEED TO PASS BODY 
export const POST_CALENDAR_CSV_EP = `${BORQS_URL}/data/configure/calendar`;
export const GET_STORE_MASTER_EP = `${BORQS_URL}/admin/store/master`;
export const BUY_CREDIT = `${BORQS_URL}/assetmgmt/user/buy-credit`;
export const GET_TESTIMONIALS = `${BORQS_URL}/assetmgmt/testimonial/search`;
export const GET_NEWS_UPDATES = `${BORQS_URL}/assetmgmt/news/search`; // New Endpoint
export const POST_FEEDBACK_URL = `${BORQS_URL}/assetmgmt/post`; // NEED TO ADD /{postId}/feedbacks;
export const CHANGE_POST_STATUS = `${BORQS_URL}/assetmgmt/post`; // NEED TO ADD /{postId}/state;
export const GET_ALL_TAGS = `${BORQS_URL}/assetmgmt/tags`;
export const GENERATE_AI_FEEDBACKS = `${BORQS_URL}/assetmgmt/post/{postId}/ai-feedbacks?action=trigger%20ai%20feedback%20generation`;
export const FETCH_CACHED_AI_FEEDBACKS = `${BORQS_URL}/assetmgmt/post`;
export const GET_AI_FEEDBACK_STATE = `${BORQS_URL}/assetmgmt/post/{postId}/ai-feedback-state`;
export const GET_INDIVIDUAL_REPORT = `${BORQS_URL}/assetmgmt/post`;
export const GET_ALL_PLAYERS = `${BORQS_URL}/assetmgmt/allplayers`;
export const GET_ALL_POSTS = `${BORQS_URL}/assetmgmt/allposts`;
export const MATCH_RALLY_API = `${BORQS_URL}/assetmgmt/match/rally`;
export const MATCH_META_API = `${BORQS_URL}/assetmgmt/post/match-meta`;
export const POST_ANALYZE_API = `${BORQS_URL}/post/analyze`;
export const COACH_MANUAL_FEEDBACK = `${BORQS_URL}/assetmgmt/post/{postId}/coachmanualfeedbacks`;
export const LLM_GATEWAY_SUMMARY_REPORT_API = `${LLM_GATEWAY_URL}/posts/combined-report`;
export const GET_UPLOAD_CREDENTIALS = `${BORQS_URL}/assetmgmt/user/upload-credentials`;


// Environment-aware host inference for poc/staging/production.
// Priority: explicit URL (REACT_APP_*_API_URL) > explicit host (REACT_APP_*_HOST) > hostname inference > hard default

// Defaults used if explicit env URLs are not provided
const DEFAULT_AUTH_HOST = process.env.REACT_APP_AUTH_HOST || inferDefaultHost('visist.ai');
const DEFAULT_BFF_HOST = process.env.REACT_APP_BFF_HOST || inferDefaultHost('visist.ai');

// Pre-Sign/Auth endpoints: always use HTTPS unless a full URL override is provided

export const AUTH_API_BASE_URL = process.env.REACT_APP_AUTH_API_URL || `https://${DEFAULT_BFF_HOST}`;
export const REQUEST_OTP_URL = `${AUTH_API_BASE_URL}/assetmgmt/leads/request-otp`;
export const VERIFY_OTP_URL = `${AUTH_API_BASE_URL}/assetmgmt/leads/verify-otp`;
export const SIGNUP_URL = `${AUTH_API_BASE_URL}/assetmgmt/leads/update-profile`;
export const POST_SIGNUP_COMPLETE = `${AUTH_API_BASE_URL}/assetmgmt/leads/signup/signup-complete`;

// BFF API endpoints: always use HTTPS unless a full URL override is provided
// Note: Host-only env (REACT_APP_BFF_HOST) is combined with https://

export const BFF_API_BASE_URL = process.env.REACT_APP_BFF_API_URL || `https://${DEFAULT_BFF_HOST}`;
export const BFF_ANALYZE_API = `${BFF_API_BASE_URL}/smartjournal/analyze/v2`;

// Subscription Management Endpoints
export const GET_SUBSCRIPTION_PLANS = `${BORQS_URL}/assetmgmt/subscription/plans`;
export const CREATE_SUBSCRIPTION = `${BORQS_URL}/assetmgmt/subscription`;
export const CREATE_CHECKOUT_SESSION = `${BORQS_URL}/assetmgmt/subscription/checkout`;
export const GET_MY_SUBSCRIPTIONS = `${BORQS_URL}/assetmgmt/subscription/my`;
export const GET_SUBSCRIPTION_USAGE = `${BORQS_URL}/assetmgmt/subscription/usage`;
export const GET_SUBSCRIPTION_BY_ID = (id) => `${BORQS_URL}/assetmgmt/subscription/${id}`;
export const CANCEL_SUBSCRIPTION = (id) => `${BORQS_URL}/assetmgmt/subscription/${id}/cancel`;
export const UPDATE_SUBSCRIPTION = (id) => `${BORQS_URL}/assetmgmt/subscription/${id}`;
export const GET_CHARGEBEE_PORTAL = `${BORQS_URL}/assetmgmt/subscription/portal`;
